export const HR_BANKS = [
  { name: 'PRIVREDNA BANKA ZAGREB d.d.', vbdi: '2340009' },
  { name: 'ZAGREBAČKA BANKA d.d.', vbdi: '2360000' },
  { name: 'RAIFFEISENBANK AUSTRIA d.d.', vbdi: '2484008' },
  { name: 'ERSTE & STEIERMÄRKISCHE BANK d.d.', vbdi: '2402006' },
  { name: 'SLAVONSKA BANKA d.d.', vbdi: '2393000' },
  { name: 'PODRAVSKA BANKA d.d.', vbdi: '2386002' },
  { name: 'ADDIKO BANK d.d.', vbdi: '2500009' },
  { name: 'BANKA KOVANICA d.d.', vbdi: '4133006' },
  { name: 'ISTARSKA KREDITNA BANKA UMAG d.d.', vbdi: '2380006' },
  { name: 'SOCIETE GENERALE – SPLITSKA BANKA', vbdi: '2330003' },
  { name: 'SLATINSKA BANKA d.d.', vbdi: '2412009' },
  { name: 'CREDO BANKA d.d.', vbdi: '2491005' },
  { name: 'PRIMORSKA BANKA d.d. RIJEKA', vbdi: '4132003' },
  { name: 'PARTNER BANKA d.d.', vbdi: '2408002' },
  { name: 'KARLOVAČKA BANKA d.d.', vbdi: '2400008' },
  { name: 'OTP BANKA HRVATSKA d.d.', vbdi: '2407000' },
  { name: 'VARAŽDINSKA BANKA', vbdi: '2391004' },
  { name: 'NOVA HRVATSKA BANKA d.d.', vbdi: '2503007' },
  { name: 'JADRANSKA BANKA d.d.', vbdi: '2411006' },
  { name: 'MEĐIMURSKA BANKA d.d.', vbdi: '2392007' },
  { name: 'BKS BANK AG', vbdi: '2488001' },
  { name: 'DUBROVAČKA BANKA d.d.', vbdi: '2401003' },
  { name: 'CROATIA BANKA d.d.', vbdi: '2485003' },
  { name: 'RIJEČKA BANKA d.d.', vbdi: '2300007' },
  { name: 'CENTAR BANKA d.d.', vbdi: '2382001' },
  { name: 'CASSA DI RISPARMIO DI TRIESTE', vbdi: '2499000' },
  { name: 'PRIVREDNA BANKA – LAGUNA BANKA', vbdi: '2497004' },
  { name: 'PRIVREMENI PBZ', vbdi: '2325004' },
  { name: 'VENETO BANKA d.d. ZAGREB', vbdi: '2381009' },
  { name: 'HRVATSKA POŠTANSKA BANKA d.d.', vbdi: '2390001' },
  { name: 'ŠTEDBANKA d.d.', vbdi: '2483005' },
  { name: 'AGRAM BANKA d.d.', vbdi: '2481000' },
  { name: 'BANK AUSTRIA CROATIA', vbdi: '2502004' },
  { name: 'POŽEŠKA BANKA d.d.', vbdi: '2405004' },
  { name: 'BNP-DRESDNER BANK (CROATIA) d.d.', vbdi: '2504000' },
  { name: 'IMEX BANKA d.d.', vbdi: '2492008' },
  { name: 'ADDIKO BANK d.d. (stari)', vbdi: '2426005' },
  { name: 'NAVA BANKA d.d.', vbdi: '2495009' },
  { name: 'SAMOBORSKA BANKA d.d.', vbdi: '2403009' },
  { name: 'BANCO POPOLARE CROATIA', vbdi: '4115008' },
  { name: 'ZANATSKA ŠKZ ZAGREB', vbdi: '6704001' },
  { name: 'KENTBANK d.d.', vbdi: '4124003' },
  { name: 'BANKA SPLITSKO-DALMATINSKA d.d.', vbdi: '4109006' },
  { name: 'KRAPINSKA ŠTEDIONICA KRAPINA', vbdi: '4114005' },
  { name: 'OBRTNIČKA ŠKZ ZADAR', vbdi: '6706007' },
  { name: 'J&T BANKA d.d.', vbdi: '2489004' },
  { name: 'HRVATSKA NARODNA BANKA', vbdi: '1001005' },
  { name: 'KAPTOL BANKA ZAGREB', vbdi: '2498007' },
  { name: 'OBRTNIČKA ŠTEDNA BANKA ZAGREB', vbdi: '6716000' },
  { name: 'MEĐIMURSKA ŠTEDIONICA', vbdi: '4130005' },
  { name: 'OBRTNIČKA ŠKZ VARAŽDIN', vbdi: '6705004' },
  { name: 'ŠKZ LIBERTINA', vbdi: '6702006' },
  { name: 'ALPE-JADRAN BANKA d.d. SPLIT', vbdi: '2384007' },
  { name: 'PRVA OBRTNIČKA ŠTEDIONICA', vbdi: '4119001' },
  { name: 'ISTARSKO-PRIMORSKO-GORANSKA ŠKZ', vbdi: '6710003' },
  { name: 'ZANATSKO ŠKZ ČAKOVEC', vbdi: '6703009' },
  { name: 'ŠKZ NOVA GRADIŠKA', vbdi: '6708002' }
];
